import { Directive, Input } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { Subject } from 'rxjs';
/**
 * Clase base de los componentes de la aplicacion que proporciona metodos de utilidad
 * para la gestion de suscripciones
 */
@Directive()
export abstract class BaseWidget extends BaseComponent implements OnDestroy {
  reloadSubject: Subject<boolean>;

  @Input() layoutClass: string;
  @Input() type: string;
  @Input() titleKey: string;
  @Input() descriptionKey: string;
  @Input() attributeId: string;
  @Input() attributeParams: Array<any>;
  @Input() title: string;
  @Input() description: string;
  @Input() estilos: string;
  @Input() columnsFormat: any;
  @Input() pageSize: number;

  // para la navegacion
  @Input() link: string;
  @Input() linkParamName: string; //  = 'TIPO_TAREA';
  @Input() linkParamValue: string; //  = 'TIPO_TAREA';

  //se recibe como parametro para la carga inicial del widget con los valores por defecto de los filtros (para cuadno esta parametrizado un valor por defecto de un filtro)
  filters: any;

  // public opts?: any

  ngAfterContentInit(): void {
    if (this.reloadSubject) {
      this.subscribe(this.reloadSubject, (filters) => this._reload(filters, false));
    }
    // this.reloadWidget('');
    this._reload(this.filters, true);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  filters2String(filters) {
    let filterStr = '';
    if (this.attributeParams && filters) {
      this.attributeParams.forEach(atrParam => {
        if (filterStr != '') {
          filterStr += '&'
        }
        filterStr += atrParam['ATTRIBUTEFILTERID'] + '=' + filters[atrParam['PARAMID']];
      })
      console.log('RECARGANDO WIDGET, ', filters);
      // this.loadDossiers(filterStr);
    }
    return filterStr
  }

  _reload(filters, forceReload?: boolean) {
    // solo se recarga si el widget indica que esta parametrizado
    if (this.attributeParams || forceReload) {
      let filterStr = this.filters2String(filters);
      this.reloadWidget(filterStr);
    }
  }

  abstract reloadWidget(filters: string);
}